import React from 'react';

interface MaskedIconProps {
    /** URL of a glyph on a transparent background; only its shape is used. */
    src: string;
    /** Fill colour of the glyph. */
    color: string;
    size: number;
    className?: string;
}

/** Draws a single-colour PNG glyph in any colour through a CSS mask (e.g. the parking type icons). */
const MaskedIcon: React.FC<MaskedIconProps> = ({ src, color, size, className }) => {
    const mask = `url(${src}) center / contain no-repeat`;
    return (
        <span
            aria-hidden="true"
            className={className}
            style={{
                display: 'inline-block',
                flexShrink: 0,
                width: `${size}px`,
                height: `${size}px`,
                backgroundColor: color,
                WebkitMask: mask,
                mask,
                pointerEvents: 'none',
            }}
        />
    );
};

export default MaskedIcon;
